/* global axios */
import ApiClient from './ApiClient';

class ScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  scheduledMessagesUrl(conversationId) {
    return `${this.url}/${conversationId}/scheduled_messages`;
  }

  getActive(conversationId) {
    return axios.get(`${this.scheduledMessagesUrl(conversationId)}/active`);
  }

  create(conversationId, scheduledMessage) {
    return axios.post(this.scheduledMessagesUrl(conversationId), {
      scheduled_message: scheduledMessage,
    });
  }

  update(conversationId, scheduledMessageId, scheduledMessage) {
    return axios.patch(
      `${this.scheduledMessagesUrl(conversationId)}/${scheduledMessageId}`,
      { scheduled_message: scheduledMessage }
    );
  }

  cancel(conversationId, scheduledMessageId, lockVersion) {
    return axios.delete(
      `${this.scheduledMessagesUrl(conversationId)}/${scheduledMessageId}`,
      { params: { lock_version: lockVersion } }
    );
  }
}

export default new ScheduledMessagesAPI();
